/* ============================================
   BR4NDOM — langues (EN / FR / DE)
   ============================================ */

const I18N = {
  en: {
    meta_title: "BR4NDOM · Swiss Streetwear. Not For Everyone.",
    nav_home: "Home",
    nav_manifesto: "Manifesto",
    nav_access: "Access",
    ruban_free_ch: "Free delivery in Switzerland",
    ruban_ch_only: "Switzerland only",
    ruban_available: "Available now",
    hero_status: "Drop 001 · launching soon",
    intro_tag: "Swiss streetwear",
    hero_h1: "This wasn't made<br><span class=\"ligne2\">for everyone</span><span class=\"point\">.</span>",
    hero_sous: "BR4NDOM · Swiss streetwear. Heavyweight pieces, made to last.",
    cd_intro: "Drop 001 unlocks in",
    cd_days: "Days",
    cd_hours: "Hours",
    cd_minutes: "Minutes",
    cd_seconds: "Seconds",
    btn_view: "Shop now",
    btn_join: "Join the list",
    mq_pieces: "100 pieces only",
    mq_swiss: "Swiss made mindset",
    mq_restock: "Never restocked",
    mq_notfor: "Not for everyone",
    sec_thedrop: "The tee",
    film_label: "The film",
    prod_tee: "Heavyweight oversized tee",
    prod_price: "CHF 85",
    prod_desc: "100% premium cotton, substantial enough to hold its shape, soft enough to wear daily. The tonal embroidered logo sits clean on the chest; the back print delivers the statement.",
    prod_hint: "Hover · front / back",
    btn_fulldetails: "Full details",
    fig_pieces: "Pieces. Ever.",
    fig_cotton: "Heavyweight cotton",
    fig_premium: "Premium cotton",
    fig_restocks: "Restocks",
    mani_quote: "“We don't chase trends, we create them. We don't overproduce. Each drop is limited, intentional, and made to last, because mediocrity is simply <em>not accepted</em>.”",
    mani_cite: "BR4NDOM Manifesto",
    appel_h2: "100 pieces. Then nothing.",
    appel_p: "The list gets first access. Everyone else gets the leftovers, if any.",
    foot_brand: "Brand",
    foot_follow: "Follow",
    foot_legal: "Legal",
    foot_shipping: "Shipping",
    foot_returns: "Returns",
    foot_privacy: "Privacy",
    foot_copy: "© 2026 BR4NDOM · Switzerland",
    d0_label: "You found it",
    d0_p: "The drop that never existed. Before the first tee, there was an idea: two brothers, one notebook, zero compromise. Drop 000 was never produced. It's the promise everything else is measured against. You clicked the 4, four times. You pay attention. We like that.",
    d0_close: "Return to reality",
    pp_oneof: "1 of 100",
    pp_selectsize: "Select your size",
    pp_addtocart: "Add to cart",
    pp_soldout: "Sold out",
    pp_delivery: "Free delivery · Switzerland only",
    pp_close: "Close",
    cart_title: "Your cart",
    cart_remove: "Remove",
    cart_subtotal: "Subtotal",
    cart_update: "Update",
    cart_checkout: "Checkout",
    cart_continue: "Continue shopping",
    cart_empty: "Your cart is empty.",
    cart_back: "Back to BR4NDOM",
    add_done: "Added to cart",
    add_continue: "Continue shopping",
    add_viewcart: "View cart",
    taglines: [
      "And that's exactly the point.",
      "Quality is not optional.",
      "Built from nothing. Made to last.",
      "Made to last, worn every day.",
      "Swiss design, street attitude."
    ],
    footerCites: [
      "Not for everyone. Exactly the point.",
      "Reload the page, even this line is limited.",
      "Mediocrity is simply not accepted.",
      "Quality over noise."
    ]
  },

  fr: {
    meta_title: "BR4NDOM · Streetwear suisse. Pas pour tout le monde.",
    nav_home: "Accueil",
    nav_manifesto: "Manifeste",
    nav_access: "Accès",
    ruban_free_ch: "Livraison gratuite en Suisse",
    ruban_ch_only: "Suisse uniquement",
    ruban_available: "Disponible maintenant",
    hero_status: "Drop 001 · bientôt disponible",
    intro_tag: "Swiss streetwear",
    hero_h1: "Ce n'était pas fait<br><span class=\"ligne2\">pour tout le monde</span><span class=\"point\">.</span>",
    hero_sous: "BR4NDOM · streetwear suisse. Des pièces épaisses, faites pour durer.",
    cd_intro: "Le Drop 001 sort dans",
    cd_days: "Jours",
    cd_hours: "Heures",
    cd_minutes: "Minutes",
    cd_seconds: "Secondes",
    btn_view: "Acheter",
    btn_join: "Rejoindre la liste",
    mq_pieces: "100 pièces seulement",
    mq_swiss: "Esprit Swiss made",
    mq_restock: "Jamais réassorti",
    mq_notfor: "Pas pour tout le monde",
    sec_thedrop: "Le t-shirt",
    film_label: "Le film",
    prod_tee: "T-shirt oversize épais",
    prod_price: "CHF 85",
    prod_desc: "100% coton premium, assez dense pour garder sa forme, assez doux pour être porté chaque jour. Le logo brodé ton sur ton habille le torse; l'impression au dos fait la déclaration.",
    prod_hint: "Survolez · avant / arrière",
    btn_fulldetails: "Tous les détails",
    fig_pieces: "Pièces. À jamais.",
    fig_cotton: "Coton épais",
    fig_premium: "Coton premium",
    fig_restocks: "Réassorts",
    mani_quote: "“On ne court pas après les tendances, on les crée. On ne surproduit pas. Chaque drop est limité, pensé, fait pour durer, parce que la médiocrité n'est tout simplement <em>pas tolérée</em>.”",
    mani_cite: "Manifeste BR4NDOM",
    appel_h2: "100 pièces. Puis plus rien.",
    appel_p: "La liste passe en premier. Les autres prennent ce qu'il reste, s'il en reste.",
    foot_brand: "Marque",
    foot_follow: "Suivre",
    foot_legal: "Légal",
    foot_shipping: "Livraison",
    foot_returns: "Retours",
    foot_privacy: "Confidentialité",
    foot_copy: "© 2026 BR4NDOM · Suisse",
    d0_label: "Tu l'as trouvé",
    d0_p: "Le drop qui n'a jamais existé. Avant le premier t-shirt, il y avait une idée: deux frères, un carnet, zéro compromis. Le Drop 000 n'a jamais été produit. C'est la promesse à laquelle tout le reste se mesure. Tu as cliqué quatre fois sur le 4. Tu fais attention. On aime ça.",
    d0_close: "Retour à la réalité",
    pp_oneof: "1 sur 100",
    pp_selectsize: "Choisis ta taille",
    pp_addtocart: "Ajouter au panier",
    pp_soldout: "Épuisé",
    pp_delivery: "Livraison gratuite · Suisse uniquement",
    pp_close: "Fermer",
    cart_title: "Ton panier",
    cart_remove: "Retirer",
    cart_subtotal: "Sous-total",
    cart_update: "Mettre à jour",
    cart_checkout: "Passer la commande",
    cart_continue: "Continuer mes achats",
    cart_empty: "Ton panier est vide.",
    cart_back: "Retour à BR4NDOM",
    add_done: "Ajouté au panier",
    add_continue: "Continuer mes achats",
    add_viewcart: "Voir le panier",
    taglines: [
      "Et c'est exactement le but.",
      "La qualité n'est pas une option.",
      "Parti de rien. Fait pour durer.",
      "Fait pour durer, porté chaque jour.",
      "Design suisse, attitude street."
    ],
    footerCites: [
      "Pas pour tout le monde. C'est tout le but.",
      "Recharge la page, même cette phrase est limitée.",
      "La médiocrité n'est pas tolérée.",
      "La qualité, pas le bruit."
    ]
  },

  de: {
    meta_title: "BR4NDOM · Swiss Streetwear. Nicht für jeden.",
    nav_home: "Start",
    nav_manifesto: "Manifest",
    nav_access: "Zugang",
    ruban_free_ch: "Kostenloser Versand in der Schweiz",
    ruban_ch_only: "Nur in der Schweiz",
    ruban_available: "Jetzt erhältlich",
    hero_status: "Drop 001 · bald erhältlich",
    intro_tag: "Swiss streetwear",
    hero_h1: "Das ist nicht<br><span class=\"ligne2\">für jeden gemacht</span><span class=\"point\">.</span>",
    hero_sous: "BR4NDOM · Swiss Streetwear. Schwere Teile, gemacht um zu bleiben.",
    cd_intro: "Drop 001 startet in",
    cd_days: "Tage",
    cd_hours: "Stunden",
    cd_minutes: "Minuten",
    cd_seconds: "Sekunden",
    btn_view: "Jetzt kaufen",
    btn_join: "Zur Liste",
    mq_pieces: "Nur 100 Stück",
    mq_swiss: "Swiss Made Mentalität",
    mq_restock: "Nie nachproduziert",
    mq_notfor: "Nicht für jeden",
    sec_thedrop: "Das Shirt",
    film_label: "Der Film",
    prod_tee: "Schweres Oversized-Shirt",
    prod_price: "CHF 85",
    prod_desc: "100% Premium-Baumwolle, kräftig genug um die Form zu halten, weich genug für jeden Tag. Das Ton-in-Ton gestickte Logo sitzt sauber auf der Brust; der Print auf dem Rücken setzt das Statement.",
    prod_hint: "Bewegen · vorne / hinten",
    btn_fulldetails: "Alle Details",
    fig_pieces: "Stück. Für immer.",
    fig_cotton: "Schwere Baumwolle",
    fig_premium: "Premium-Baumwolle",
    fig_restocks: "Nachschübe",
    mani_quote: "“Wir jagen keinen Trends hinterher, wir schaffen sie. Wir überproduzieren nicht. Jeder Drop ist limitiert, bewusst und gemacht um zu bleiben, denn Mittelmass wird einfach <em>nicht akzeptiert</em>.”",
    mani_cite: "BR4NDOM Manifest",
    appel_h2: "100 Stück. Dann nichts mehr.",
    appel_p: "Die Liste kommt zuerst. Der Rest bekommt, was übrig bleibt, falls überhaupt.",
    foot_brand: "Marke",
    foot_follow: "Folgen",
    foot_legal: "Rechtliches",
    foot_shipping: "Versand",
    foot_returns: "Rückgabe",
    foot_privacy: "Datenschutz",
    foot_copy: "© 2026 BR4NDOM · Schweiz",
    d0_label: "Du hast es gefunden",
    d0_p: "Der Drop, den es nie gab. Vor dem ersten Shirt gab es eine Idee: zwei Brüder, ein Notizbuch, null Kompromisse. Drop 000 wurde nie produziert. Es ist das Versprechen, an dem sich alles andere misst. Du hast viermal auf die 4 geklickt. Du passt auf. Das gefällt uns.",
    d0_close: "Zurück zur Realität",
    pp_oneof: "1 von 100",
    pp_selectsize: "Wähle deine Grösse",
    pp_addtocart: "In den Warenkorb",
    pp_soldout: "Ausverkauft",
    pp_delivery: "Kostenloser Versand · nur Schweiz",
    pp_close: "Schliessen",
    cart_title: "Dein Warenkorb",
    cart_remove: "Entfernen",
    cart_subtotal: "Zwischensumme",
    cart_update: "Aktualisieren",
    cart_checkout: "Zur Kasse",
    cart_continue: "Weiter einkaufen",
    cart_empty: "Dein Warenkorb ist leer.",
    cart_back: "Zurück zu BR4NDOM",
    add_done: "Zum Warenkorb hinzugefügt",
    add_continue: "Weiter einkaufen",
    add_viewcart: "Warenkorb ansehen",
    taglines: [
      "Und genau das ist der Punkt.",
      "Qualität ist keine Option.",
      "Aus dem Nichts gebaut. Gemacht um zu bleiben.",
      "Gemacht um zu bleiben, jeden Tag getragen.",
      "Schweizer Design, Street-Attitude."
    ],
    footerCites: [
      "Nicht für jeden. Genau das ist der Punkt.",
      "Lade die Seite neu, sogar diese Zeile ist limitiert.",
      "Mittelmass wird nicht akzeptiert.",
      "Qualität statt Lärm."
    ]
  }
};

(function () {
  const LANGS = ['en', 'fr', 'de'];

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function appliquer(lang) {
    if (!I18N[lang]) lang = 'en';
    const dict = I18N[lang];

    document.documentElement.setAttribute('lang', lang);
    if (dict.meta_title) document.title = dict.meta_title;

    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      const cle = el.getAttribute('data-i18n');
      if (dict[cle] != null) el.innerHTML = dict[cle];
    });

    // phrases aléatoires (une par affichage), dans la langue choisie
    const heroCite = document.getElementById('citation-hero');
    if (heroCite) heroCite.textContent = pick(I18N.en.taglines);
    const footCite = document.getElementById('citation-footer');
    if (footCite && dict.footerCites) footCite.textContent = pick(dict.footerCites);

    document.querySelectorAll('[data-lang]').forEach(function (b) {
      b.classList.toggle('actif', b.getAttribute('data-lang') === lang);
    });

    try { localStorage.setItem('brandom_lang', lang); } catch (e) {}
  }

  // langue de départ : d'abord la langue Shopify de l'adresse (si dispo),
  // sinon la préférence sauvegardée, sinon la langue du navigateur.
  let depart = null;
  if (window.BR_LOCALE && I18N[window.BR_LOCALE]) depart = window.BR_LOCALE;
  if (!depart) { try { depart = localStorage.getItem('brandom_lang'); } catch (e) {} }
  if (!depart) {
    const nav = (navigator.language || 'en').slice(0, 2).toLowerCase();
    depart = LANGS.indexOf(nav) !== -1 ? nav : 'en';
  }

  appliquer(depart);

  // Change la langue Shopify en allant sur l'adresse localisée (/en, /de, ...).
  // C'est ce qui fait suivre tout le site ET le checkout.
  // Repli (une seule langue publiée) : simple bascule du texte.
  function basculeLangue(code) {
    var map = window.BR_LOCALES;
    if (!map || map[code] == null) return false;
    function pfx(iso) { return (map[iso] || '/').replace(/\/+$/, ''); }
    var courant = pfx(window.BR_LOCALE);
    var chemin = location.pathname;
    if (courant && (chemin === courant || chemin.indexOf(courant + '/') === 0)) {
      chemin = chemin.slice(courant.length) || '/';
    }
    var cible = pfx(code) + chemin;
    if (cible.charAt(0) !== '/') cible = '/' + cible;
    try { localStorage.setItem('brandom_lang', code); } catch (err) {}
    location.href = cible + location.search;
    return true;
  }

  document.querySelectorAll('[data-lang]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var code = b.getAttribute('data-lang');
      if (!basculeLangue(code)) {
        try { localStorage.setItem('brandom_lang', code); } catch (err) {}
        appliquer(code);
      }
    });
  });

  // accessible depuis le reste du site si besoin
  window.brandomSetLang = appliquer;
})();
